import {
  COMPONENT_VALUE_TYPES as types,
  DIRECTIONS,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'container',
    label: 'Container',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT
      },
      {
        key: 'paddingTop',
        label: 'Top Padding',
        type: types.TEXT
      },
      {
        key: 'paddingBottom',
        label: 'Bottom Padding',
        type: types.TEXT
      },
      {
        key: 'paddingLeft',
        label: 'Left Padding',
        type: types.TEXT
      },
      {
        key: 'paddingRight',
        label: 'Padding Right',
        type: types.TEXT
      },
      {
        key: 'backgroundColor',
        label: 'Background Color',
        type: types.COLOR_PICKER
      },
      {
        key: 'backgroundImage',
        label: 'Background Image',
        type: types.S3_ASSET_URL
      },
      {
        key: 'backgroundPosition',
        label: 'Background Position',
        type: types.TEXT,
      }
    ]
  },
  {
    key: 'content',
    label: 'Content',
    type: types.OBJECT,
    children: [
      {
        key: 'width',
        label: 'Width',
        type: types.TEXT
      },
      {
        key: 'font',
        label: 'Font',
        type: types.TEXT
      },
      {
        key: 'horizontalPosition',
        label: 'Horizontal Position',
        type: types.ENUM,
        options: ['left', 'center', 'right']
      },
      {
        key: 'verticalPosition',
        label: 'Vertical Position',
        type: types.ENUM,
        options: ['top', 'center', 'bottom']
      },
      {
        key: 'alignmentOnMobile',
        label: 'Alignment on Mobile',
        type: types.ENUM,
        options: ['left', 'center', 'right']
      },
      {
        key: 'titles',
        label: 'Titles',
        type: types.ARRAY,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXT
          },
          {
            key: 'fontSize',
            label: 'Font Size',
            type: types.TEXT
          },
          {
            key: 'color',
            label: 'Color',
            type: types.COLOR_PICKER
          },
          {
            key: 'gradient',
            label: 'Title Gradient',
            type: types.TEXT,
            tooltip: 'CSS gradient string. If provided, gradient will be used instead of color. Example: linear-gradient(90deg, #FFD9A5, #FFA500)'
          },
          {
            key: 'margin',
            label: 'Margin',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'descriptions',
        label: 'Descriptions',
        type: types.ARRAY,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXT
          },
          {
            key: 'fontSize',
            label: 'Font Size',
            type: types.TEXT
          },
          {
            key: 'lineHeight',
            label: 'Line Height',
            type: types.TEXT
          },
          {
            key: 'color',
            label: 'Color',
            type: types.COLOR_PICKER
          },
          {
            key: 'margin',
            label: 'Margin',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'link',
        label: 'Link',
        type: types.OBJECT,
        children: [
          {
            key: 'text',
            label: 'Text',
            type: types.TEXT
          },
          {
            key: 'fontSize',
            label: 'Font Size',
            type: types.TEXT
          },
          {
            key: 'color',
            label: 'Color',
            type: types.COLOR_PICKER
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
        ]
      }
    ]
  },
  {
    key: 'animation',
    label: 'Animation',
    type: types.OBJECT,
    children: [
      {
        key: 'enabled',
        label: 'Enable Animation',
        type: types.BOOLEAN,
      },
      {
        key: 'type',
        label: 'Animation Type',
        type: types.ENUM,
        options: ['FADE', 'SLIDE', 'SCALE'],
      },
      {
        key: 'direction',
        label: 'Direction (for Slide)',
        type: types.ENUM,
        options: DIRECTIONS,
      },
      {
        key: 'duration',
        label: 'Duration (s)',
        type: types.TEXT,
      },
      {
        key: 'initialDelay',
        label: 'Initial Delay (s)',
        type: types.TEXT,
      },
      {
        key: 'stagger',
        label: 'Stagger Delay (s)',
        type: types.TEXT,
        tooltip: 'Delay between each item\'s animation start.',
      },
      {
        key: 'animateHeader',
        label: 'Animate Header',
        type: types.BOOLEAN,
      },
      {
        key: 'animateBlocks',
        label: 'Animate Content',
        type: types.BOOLEAN,
      },
    ],
  },
];

const defaultProps = {
  container: {
    width: '100%',
    paddingLeft: '15%',
    paddingRight: '15%',
    paddingTop: '0px',
    paddingBottom: '0px',
    backgroundPosition: 'center center',
    backgroundImage: 'https://ff-genesis-cdn-dev.s3.us-west-2.amazonaws.com/evan-test/source_20250815_006_04.jpg',
  },
  content: {
    font: 'Roboto',
    horizontalPosition: 'left',
    verticalPosition: 'center',
    titles: [
      {
        text: 'I. _______________',
        fontSize: '36px',
        color: '#C6AA84'
      },
      {
        text: 'C10 Treasury',
        fontSize: '36px',
        color: '#C6AA84'
      },
    ],
    descriptions: [
      {
        text: 'Institutional-Grade Crypto Asset Management',
        fontSize: '14px',
        lineHeight: '1.6',
        color: '#B5B5B5',
        margin: '0px 0px 6px 0px'
      },
      {
        text: 'Strategic crypto treasury management',
        fontSize: '14px',
        lineHeight: '1.6',
        color: '#B5B5B5',
        margin: '0px 0px 6px 0px'
      },
      {
        text: 'Management of diversified crypto asset portfolios',
        fontSize: '14px',
        lineHeight: '1.6',
        color: '#B5B5B5',
        margin: '0px 0px 6px 0px'
      },
      {
        text: '80% passive allocation + 20% active management strategy',
        fontSize: '14px',
        lineHeight: '1.6',
        color: '#B5B5B5',
        margin: '0px 0px 18px 0px'
      },
      {
        text: 'Professional risk management and compliance framework',
        fontSize: '14px',
        lineHeight: '1.6',
        color: '#B5B5B5',
        margin: '0px 0px 0px 0px'
      },
    ],
    link: {
      text: 'Discover >',
      fontSize: '18px',
      color: '#B5B5B5',
      url: 'https://www.ff.com'
    }
  },
  animation: {
    enabled: false,
    type: 'SLIDE',
    direction: 'UP',
    duration: 0.8,
    initialDelay: 0,
    stagger: 0.2,
    animateHeader: true,
    animateBlocks: true,
  },
};

export default {
  title: 'C10 Hero Section',
  id: 'C10HeroSection',
  propsSchema,
  defaultProps
};








